import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { transactionState } from "../../recoil/atoms";
import { LOADING_PAGE_URL, utilityRoutes } from "../../routing/routes.config";
import useApiClient from "../useApiClient";

export const useGetWebChatInformation = () => {
  const client = useApiClient();
  const location = useLocation();
  const currentTransactionState = useRecoilValue(transactionState);

  const disallowPages = [
    ...utilityRoutes.map((route) => route.path.toLowerCase()),
    LOADING_PAGE_URL.toLowerCase(),
    process.env.REACT_APP_HOMEPAGE?.toLowerCase(),
  ];

  const currentLocation = location.pathname.toLowerCase();
  const shouldGetWebChatInformation = !disallowPages?.includes(currentLocation);

  const tokenQuery = currentTransactionState?.tokenQuery;
  const [pointOfContactId, setPointOfContactId] = useState("");
  const [crmId, setCrmId] = useState("");
  const [shouldRenderWebChat, setShouldRenderWebChat] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    const getWebChatId = async () => {
      try {
        if (!isCancelled) {
          if (shouldGetWebChatInformation) {
            const token = tokenQuery ?? "";
            const response = await client.getWebChatContactId(token);

            if (isCancelled) return;

            setPointOfContactId(response.result.pointOfContactId);
            setCrmId(response.result.crmId ?? "");
            setShouldRenderWebChat(true);
          } else {
            setShouldRenderWebChat(false);
          }
        }
      } catch {
        if (!isCancelled) {
          setPointOfContactId("");
          setCrmId("");
          setShouldRenderWebChat(false);
        }
      }
    };

    getWebChatId();

    return () => {
      isCancelled = true;
    };
  }, [client, currentLocation, shouldGetWebChatInformation, tokenQuery]);

  return {
    pointOfContactId: pointOfContactId,
    crmId: crmId,
    shouldRender: shouldRenderWebChat,
  };
};

export default useGetWebChatInformation;
